import * as React from "react"

export default function HeroVideo({
    srcMp4,
    srcWebm
}) {
    let videoSources = [];
    if (srcMp4) {
        videoSources.push(
            <source
                src={srcMp4}
                type="video/mp4" />
        );
    }

    if (srcWebm) {
        videoSources.push(
            <source
                src={srcWebm}
                type="video/webm" />
        );
    }

    return (
        <>
            <div className="hero-video-container">
                <div className="hero-video-inner">
                    <video autoPlay muted playsInline disablePictureInPicture preload="auto">
                        {
                            videoSources.map(videoSource => videoSource)
                        }
                    </video>
                </div>
            </div>
        </>
    )
}